// eslint-disable-next-line
import React, { useState, useContext } from 'react'
import { Loading } from '../helpers/Loading'
import { Pagination } from '../helpers/Pagination'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'
import { Link } from 'react-router-dom'
import { getTime } from '../../utils/convert-time'
import { RiMore2Line, RiPlayLine } from 'react-icons/ri'

/** Search results on enter component**/
export const SearchResultsList = ( { results, loading } ) => {
  const [currentPage, setCurrentPage] = useState( 1 )
  const [resultsPerPage] = useState( 15 )
  let resultsArr = []

  // eslint-disable-next-line no-empty-pattern
  const [{ }, dispatch] = useContext( GlobalMusicContext )
  const setCurrentTrack = ( data ) => {
    dispatch( { type: "setCurrentTrack", snippet: data } )
  }

  const handlePlayTrack = ( index ) => {
    let song = results?.songs[index]
    setCurrentTrack( song )
  }

  const indexOfLastSong = currentPage * resultsPerPage
  const indexOfFirstSong = indexOfLastSong - resultsPerPage
  const currentSongs = results?.songs?.slice( indexOfFirstSong, indexOfLastSong )
  const nextPage = ( pageNumber ) => setCurrentPage( pageNumber )

  if ( currentSongs ) {
    resultsArr = currentSongs.map( song => {
      let index = results?.songs.indexOf( song )
      return (
        <Link key={song.id} to={`/song/${song.id}`}>
          <li className="results__item">
            <span>{index + 1}</span>
            <p>{song.name}</p>
            <p>
              {song?.artists?.map( ( { name } ) => name ).join( " & " )}
            </p>
            <span>{getTime( song.duration )}</span>
            <span>
              <RiPlayLine
                onClick={() => handlePlayTrack( index )}
              />
            </span>
            <span className="heart__svg">
              <RiMore2Line />
            </span>
          </li>
        </Link>
      )
    } )
  } else if ( loading || !results.songs ) {
    return <Loading />
  }

  return (
    <div className="search__results overlay">
      <div className="results__wrapper">
        <ul className="results__list">
          {resultsArr}
        </ul>
        {results?.songCount > currentSongs?.length
          ? <Pagination
            resultsPerPage={resultsPerPage}
            totalResults={results?.songs.length}
            nextPage={nextPage}
          />
          : null
        }
      </div>
    </div>
  )
}
/** For all 600 songs
    {results?.songCount > currentSongs?.length ? <Pagination
    totalResults={results?.songCount} />
  */